import { Route, Routes } from "react-router-dom";
import Layout from "@/components/Layout/Layout";
import ScrollToTop from "@/components/ScrollToTop/ScrollToTop";
import SeoRoute from "@/components/SeoRoute/SeoRoute";
import HomePage from "@/pages/Home/HomePage";
import AboutPage from "@/pages/About/AboutPage";
import WorkWithPage from "@/pages/WorkWith/WorkWithPage";
import AreasOfFocusPage from "@/pages/AreasOfFocus/AreasOfFocusPage";
import ModalitiesPage from "@/pages/Modalities/ModalitiesPage";
import BrainspottingPage from "@/pages/Modalities/BrainspottingPage";
import SupervisionPage from "@/pages/Supervision/SupervisionPage";
import FeesPage from "@/pages/Fees/FeesPage";
import ContactPage from "@/pages/Contact/ContactPage";
import NotFoundPage from "@/pages/NotFound/NotFoundPage";

export default function App() {
  return (
    <>
      <ScrollToTop />
      <SeoRoute />
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="who-i-work-with" element={<WorkWithPage />} />
          <Route path="areas-of-focus" element={<AreasOfFocusPage />} />
          <Route path="modalities" element={<ModalitiesPage />} />
          <Route path="modalities/brainspotting" element={<BrainspottingPage />} />
          <Route path="supervision" element={<SupervisionPage />} />
          <Route path="fees" element={<FeesPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </>
  );
}
